import { render, staticRenderFns } from "./task-audit.vue?vue&type=template&id=3c1df194&scoped=true&"
import script from "./task-audit.vue?vue&type=script&lang=js&"
export * from "./task-audit.vue?vue&type=script&lang=js&"
import style0 from "./task-audit.vue?vue&type=style&index=0&id=3c1df194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1df194",
  null
  
)

export default component.exports